
import Vue from "vue";
//import { Resource } from "../models/Resource";
import { SearchResponseDocument } from "search-api-client/lib/models";
import { formatISODateMMDDYYYY } from "@/common/date";
export default Vue.extend({
  name: "Result",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: [],
    },
  },
  computed: {
    highlights() {
      if (this.result.highlights.description != null) {
        return this.$sanitize(this.result.highlights.description[0]);
      } else if (this.result.highlights.content != null) {
        return this.$sanitize(this.result.highlights.content[0]);
      } else if (this.result.highlights.nestedContent != null) {
        return this.$sanitize(this.result.highlights.nestedContent[0]);
      }
      return this.result.content;
    },
  },
  methods: {
    formatISODate(input: string) {
      return formatISODateMMDDYYYY(input);
    },
  },
});
